import { storeToRefs } from 'pinia';
import {
  useLogsActionsDrawerStore,
  type LogsActionsDrawerContext,
} from '../stores/logsActionsDrawerStore';

export const useLogsActionsDrawer = () => {
  const logsActionsDrawerStore = useLogsActionsDrawerStore();
  const {
    isOpen,
    serviceName,
    initialUsername,
    initialFullname,
    initialFrom,
    initialTo,
    initialMinStatusCode,
    initialMaxStatusCode,
    initialTop,
  } = storeToRefs(logsActionsDrawerStore);

  const openLogsActionsDrawer = (context: LogsActionsDrawerContext) => {
    logsActionsDrawerStore.open(context);
  };

  const closeLogsActionsDrawer = () => {
    logsActionsDrawerStore.close();
  };

  const closeAndResetLogsActionsDrawer = () => {
    logsActionsDrawerStore.closeAndReset();
  };

  return {
    isOpen,
    serviceName,
    initialUsername,
    initialFullname,
    initialFrom,
    initialTo,
    initialMinStatusCode,
    initialMaxStatusCode,
    initialTop,
    openLogsActionsDrawer,
    closeLogsActionsDrawer,
    closeAndResetLogsActionsDrawer,
  };
};
